/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align whitespace quotemark */

import {
  ComponentFactoryResolver,
  EmbeddedViewRef,
  ViewContainerRef
}                                 from '@angular/core';

import { DocumentWindow }         from './document.window';
import { DocumentWindowManager }  from './document.window.manager';
import { Logger }                 from '@/util/logger';



import * as $                     from 'jquery';

import {Subscription}             from 'rxjs';
import {ResizeObserver}           from 'resize-observer';
import {DocumentMetadata}         from '@/screens/ide/document.metadata';
import {ServiceManager}           from "@/services/service.manager";
import {RegressionViewerMetadata}  from "@/screens/ide/regression.viewer.metadata";
import {RegressionViewerComponent} from "@/components/regression.viewer.component";
import {basename, empty} from "@/util/util";

/**
 *
 * @class RegressionViewerWindow
 *
 * window for viewing regressions
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2022
 *
 */
export class RegressionViewerWindow extends DocumentWindow {

  /** access to the various services */
  private services:      ServiceManager = null;

  /** the document manager we are a tab  of */
  private manager: DocumentWindowManager = null;

  /** the blob with the actual regression data */
  private blob: string                   = '';

  /** name of the regression */
  private name: string                   = '';

  /** the Angular component that is the actual regression view panel component...which we are hosting */
  private viewer: RegressionViewerComponent   = null;

  /** the resizer tracker */
  private resizeObserver: ResizeObserver = null;

  /** the observable we use to know when the component is ready */
  private readySub: Subscription;

  /** standard constructor */
  constructor(
    meta: RegressionViewerMetadata,
    manager: DocumentWindowManager
  ) {

    super(manager, meta, manager.layoutManager());

    Logger.debug('[RegressionViewerWindow] constructing...');

    this.services = manager.serviceManager();
    this.manager  = manager;

    this.blob     = meta.blob;
    this.name     = meta.name;

    if (empty(this.name)) {

      this.name = basename(meta.blob);
    }

    this.title = this.name;

    this.initViewer();
  }

  /** fetch my metadata */
  public myMeta(): RegressionViewerMetadata {

    return this.meta as RegressionViewerMetadata;
  }

  /** restore the view (on current 'focus') */
  public initViewer() {

    Logger.debug(`[RegressionViewerWindow] => `, this.meta);

    const rvw: RegressionViewerWindow = this;

    const container: JQuery<HTMLElement> = $(`#${this.meta.id}`);

    if (!$(container) || !$(container).is('div')) {

      this.unReady();

      Logger.error(`[RegressionViewerWindow] missing hosting container (${rvw.meta.id})!`);

      return ;
    }

    $(container).html(`
<div id="regression_viewer_${rvw.meta.id}" class="regressionviewerpanelshell">
</div>
`);

    /*
     * wait for the HTML to actually update with the component selector above, this won't create the
     * component, its just HTML :)  But, we can use Angular's component factory etc. to create the
     * component and effective "host" an Angular component inside our DocumentWindow (which isn't
     * Angular based).
     *
     */

    const checkExist = setInterval(() => {

      const dom: HTMLElement = document.getElementById(`regression_viewer_${rvw.meta.id}`) as HTMLElement;

      if (!dom) {

        return;
      }

      clearInterval(checkExist);

      Logger.debug(`[RegressionViewerWindow] inject regression viewer component ...`);

      const    view: ViewContainerRef         = rvw.services.ide.view;
      const factory: ComponentFactoryResolver = rvw.services.ide.componentResolver;


      const creator      = factory.resolveComponentFactory(RegressionViewerComponent);
      const componentRef = view.createComponent(creator);

      rvw.viewer        = componentRef.instance  as RegressionViewerComponent;

      const domElem      = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

      /* ensure the new component is parented under our container */

      dom.appendChild(domElem);

      /*
       * add a self watch for changes in wrapper size...because sometime it will change because
       * the panels around it have changed in size...not because the browser has changed in size;
       * that is, its not a window resize event, so that kind of size change wouldn't normally
       * be caught.
       *
       */

      rvw.resizeObserver = new ResizeObserver(entries => {

        rvw.viewer.resize();

      });

      rvw.resizeObserver.observe( dom );

      this.viewer.reloaded = () => {

        Logger.debug(`[RegressionViewerWindow] child content changed...`);


      };

      Logger.debug(`[RegressionViewerWindow]  component is ready, setting regression...`);

      rvw.viewer.manager  = rvw.manager;
      rvw.viewer.window   = rvw;

      this.readySub = rvw.viewer.ready.subscribe((status: boolean) => {

        if (status == false) {

          return;
        }

        /* do any init still remaining before we go live ... */

        rvw.viewer.finalize();

        /* go ahead and do the first time load */

        rvw.refocus(this.meta);

        /* register this window in its anchor group, first one is always the anchor. */

        if (rvw.manager.anchor(rvw.type) == null) {

          /*
           * there is no anchor yet, so use this one; we always default to the most
           * recently created window.
           *
           */

          rvw.manager.dropAnchor(rvw.type, rvw);
          rvw.viewer.dropAnchor();
        }

      });

    }, 100);
  }

  /** after initialization, some windows may allow for resetting to new content to view */
  public refocus(meta: DocumentMetadata) {

    if (this.viewer == null) {

      return ;
    }

    Logger.debug(`[RegressionViewerWindow] loading: `, meta);

    this.meta = meta;

    /* on demand loading of a tree */

    this.viewer.refocus(this.myMeta());

    /* update our title if needed */

    this.updateFocus();
  }

  public close(implied: boolean = false) {

    Logger.debug(`[RegressionViewerWindow] closing!`);

    if (this.viewer != null) {

      this.viewer.close();

      this.viewer = null;
    }

    if (this.resizeObserver != null) {

      this.resizeObserver.disconnect();

      this.resizeObserver = null;
    }

    this.readySub.unsubscribe();

    super.close(implied);
  }

  /** update the focus to current */
  private updateFocus() {

    Logger.debug(`[RegressionViewerWindow] focus updating...`);

    this.title = this.myMeta().name;

    if (empty(this.title)) {

      this.title = basename(this.myMeta().blob)
    }

  }

}
